/* istanbul ignore file */
import { UpdatePageLayout } from 'framework/ui/layout';
import { UpdateForm } from 'framework/form';
import VacancyPublicationForm from 'domain/recruiting/vacancy/publication/createupdate/VacancyPublicationForm';
import useVacancyPublicationService from 'domain/recruiting/vacancy/publication/shared/vacancyPublicationService';
import { useVacancyPublicationUrl } from 'domain/recruiting/vacancy/publication/vacancyPublicationRoute';
import VacancyPublicationEntityHeader from 'domain/recruiting/vacancy/publication/shared/VacancyPublicationEntityHeader';
import UpdateVacancyPublicationBreadcrumbs from 'domain/recruiting/vacancy/publication/createupdate/Update/Breadcrumbs';

const UpdateVacancyPublication = () => {
  const { updateVacancy, getVacancyById, getValidationSchema } = useVacancyPublicationService();
  const { getSingleEntityUrl } = useVacancyPublicationUrl();

  return (
    <UpdateForm
      submitFormFunc={updateVacancy}
      getDataFunc={getVacancyById}
      getValidationSchemaFunc={getValidationSchema}
      afterSubmit={{
        redirect: getSingleEntityUrl(),
        message: 'You are awesome! The Vacancy Publication has been successfully saved.',
      }}
    >
      <UpdatePageLayout
        title="Edit: Vacancy Publication"
        breadcrumbs={<UpdateVacancyPublicationBreadcrumbs />}
        entityHeader={<VacancyPublicationEntityHeader />}
      >
        <VacancyPublicationForm />
      </UpdatePageLayout>
    </UpdateForm>
  );
};

export default UpdateVacancyPublication;
